import { REVIEW_COMMENT_API, ZAN } from "@/config/api";
import HandlePhpFetch from "@/src/utils/fetch/PhpFetch";
import { VISITOR_COOKIE_NAME } from "@/config/constConf";
import { getCookieItem } from "@/lib/commonService";

function getVistorId() {
    let cookieDataRecord;
    try {
        const cookieData = getCookieItem(VISITOR_COOKIE_NAME) ?? "";
        cookieDataRecord = JSON.parse(cookieData);
    } catch (e) {
        console.error("getVistorId", e);
    }
    const visitor_id = cookieDataRecord ? cookieDataRecord.visitor_id : "";
    return visitor_id;
}

/**
 *
 *
 * @param {*} data
 * @returns promise
 */
export const postReview = (data: Record<string, any>) => {
    return HandlePhpFetch.post(REVIEW_COMMENT_API, data);
};

export const zan = (reviews_id: number) => {
    const visitor_id = getVistorId();
    return HandlePhpFetch.post(ZAN, { reviews_id, visitor_id });
};
